import {number, string, type} from 'io-ts';

export function isReportableServerError(thing: unknown): thing is ReportableServerError {
    return !!thing && typeof thing === 'object' && 'message' in thing && typeof thing.message === 'string';
}

export function isErroneousServerResult(thing: unknown): thing is ErroneousServerResult {
    return isReportableServerError(thing) && 'code' in thing && typeof thing.code === 'number';
}

export const ReportableServerError = {
    '~standard': type({
        message: string,
    })['~standard'],
};
export type ReportableServerError = ({} & (typeof ReportableServerError)['~standard']['types'])['output'];

export const ErroneousServerResult = {
    '~standard': type({
        message: string,
        code: number,
    })['~standard'],
};
export type ErroneousServerResult = ({} & (typeof ErroneousServerResult)['~standard']['types'])['output'];
